import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN_1 = process.env.REACT_APP_MIXPANEL_WEB_TOKEN;
const MIXPANEL_TOKEN_2 = process.env.REACT_APP_MIXPANEL_CENTRAILIZED_TOKEN;

const IS_DEV = process.env.NODE_ENV === "development";

let isInitialized = false;
let instances = [];

export const initAnalytics = () => {
    if (IS_DEV) return;

    if (!MIXPANEL_TOKEN_1 || !MIXPANEL_TOKEN_2) {
        console.warn(
            "One or more Mixpanel tokens are missing. Analytics will not be tracked."
        );
        return;
    }

    // Primary Mixpanel project
    mixpanel.init(MIXPANEL_TOKEN_1, {
        autocapture: false,
        record_sessions_percent: 10,
        persistence: "localStorage",
        cross_subdomain_cookie: true,
    });

    // Secondary Mixpanel project
    const secondaryInstance = mixpanel.init(
        MIXPANEL_TOKEN_2,
        {
            autocapture: false,
            record_sessions_percent: 0,
            persistence: "localStorage",
            cross_subdomain_cookie: true,
        },
        "secondary"
    );

    instances = [mixpanel, secondaryInstance];
    isInitialized = true;

    console.log("Mixpanel initialized for both projects");
};

export const trackEvent = (eventName, properties = {}) => {
    if (!isInitialized) {
        console.warn(
            `Mixpanel not initialized. Skipping event: ${eventName}`
        );
        return;
    }

    instances.forEach((instance) => {
        instance.track(eventName, properties);
    });

    console.log("Tracked Event:", eventName, properties);
};

export const identifyUser = (userId, traits = {}) => {
    if (!isInitialized) return;

    const distinctId = `+${userId}`;

    instances.forEach((instance) => {
        instance.identify(distinctId);
        instance.people.set(traits);
    });

    console.log("Tracked User:", userId, traits);
};

export const resetUser = () => {
    if (!isInitialized) return;

    instances.forEach((instance) => {
        instance.reset();
    });

    console.log("Mixpanel user reset");
}